<style lang="scss">
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";

  .day-labels {
    display: flex;
    font-size: utils.in_rem(10px);
    font-style: normal;
    width: 100%;
    padding: 0;
    font-weight: 700;
    line-height: utils.in_rem(21px);
    flex-direction: row;
    justify-content: space-between;
  }
  .day-label {
    width: utils.in_rem(40px);
    text-align: center;
    @include colors.color(textBlack);
  }
</style>

<script>
  const dayLabels = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
</script>

<div class="day-labels">
  {#each dayLabels as label}
    <div class="day-label">{label}</div>
  {/each}
</div>
